import { Input } from 'ui';
import { withMask } from 'hocs/withMask';

export const MaskedInput = withMask(Input);
